module.exports = __webpack_public_path__ + "img/Klizer_White_JustLogo.e872fd3b.png";